module.exports = __webpack_public_path__ + "908d014b5cb4b2d110e46d5c90a29518.svg";